import React from 'react';
import loadable from '@loadable/component';
import connectRoute from 'app/routes/connectRoute';
import AccountMessagesActions from 'app/actions/MessagesActions';
import BorrowingActions from 'app/actions/BorrowingActions';
import { currentAccountSelector } from 'app/selectors/AuthSelector';
import { currentLibrarySelector } from 'app/selectors/LibrarySelector';

const AccountMessagesContainer = loadable(() => import('app/containers/AccountMessagesContainer'));

export function AccountMessagesPageRoute() {
  return <AccountMessagesContainer />;
}

function getRouteData({ dispatch, state }) {
  const account = currentAccountSelector(state);
  const library = currentLibrarySelector(state);
  const accountId = account && account.get('id');
  if (!accountId) return [];

  if (!library.get('accountMessages')) {
    return [dispatch(BorrowingActions.fetchSummaries({ accountId }))];
  }

  return [
    dispatch(BorrowingActions.fetchSummaries({ accountId })),
    dispatch(AccountMessagesActions.fetchMessages({ accountId }))
  ];
}

export default connectRoute(AccountMessagesPageRoute, { getRouteData });
